import React from "react";
import GenerateInvoiceList from "../../features/GenerateInvoiceList/GenerateInvoiceList";
import "./GenerateInvoice.scss";

const GenerateInvoice = () => {
  return (
    <div className="analytics-page">
      <GenerateInvoiceList />
    </div>
  );
};

export default GenerateInvoice;
